import * as React from "react";
import { pure } from "recompose";
import styled from "styled-components";

import { Text } from "../../../../components/atoms";
import { DateTimeCard } from "../../../../components/molecules";
import { config } from "../../../../config";
import { ScrollerContainer } from "../../../../containers/common";
import { ITherapistAvailability } from "../../../../services/api/therapists";
import { theme } from "../../../../theme";
import { availableDateTime, dateFromIso } from "../../../../utils/index";

interface IProps {
  availableDates?: ITherapistAvailability;
  dateIndexSelected: number;
  onSelectDate(date: string): void;
  selectedDate: string;
}

const FilterDateScrollerWrapper = styled.div`
  margin-bottom: 16px;

  svg {
    margin-top: 32px;
    fill: ${theme.color.ruubyBlack};
  }
`;

const FilterDateBlock = styled.div`
  display: inline-flex;

  > div {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const FilterDateMonth = Text.extend`
  margin-bottom: 7px;
`;

const FilterDateCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const initialTimeForDate = config.dateTime.time.initial;
const currentDate = dateFromIso("min").set(initialTimeForDate);
const endDate = dateFromIso("min").plus(config.dateTime.date.range);
const dateRange: string[] = [];
let iteratedDate = currentDate;

while (iteratedDate.valueOf() < endDate.valueOf()) {
  dateRange.push(iteratedDate.toISO());
  iteratedDate = iteratedDate.plus({ days: 1 });
}

const FilterDate: React.FC<IProps> = (props) => {
  const showMonth = (date: string, index: number) => {
    const isoDate = dateFromIso(date);

    if (index === 0 || isoDate.day === 1) {
      return (
        <FilterDateMonth size="12">{isoDate.toFormat("LLLL")}</FilterDateMonth>
      );
    }
  };

  const mapDates = dateRange.map((date: string, index) => {
    const weekdayFormatted = dateFromIso(date).toFormat("cccc");
    const dayFormatted = dateFromIso(date).toFormat("dd");
    const selected =
      dateFromIso(props.selectedDate).toISODate() ===
      dateFromIso(date).toISODate();
    const isAvailable = props.availableDates
      ? Boolean(props.availableDates[availableDateTime(date).date])
      : true;

    return (
      <FilterDateCardWrapper key={date}>
        {showMonth(date, index)}
        <DateTimeCard
          active={selected}
          available={isAvailable}
          day={dayFormatted}
          fullDate={date}
          key={index}
          onSelect={props.onSelectDate}
          type="date"
          weekday={weekdayFormatted}
        />
      </FilterDateCardWrapper>
    );
  });

  return (
    <FilterDateScrollerWrapper>
      <ScrollerContainer
        itemIndexIn={props.dateIndexSelected}
        centerElementsIfMobile={true}
      >
        <FilterDateBlock>{mapDates}</FilterDateBlock>
      </ScrollerContainer>
    </FilterDateScrollerWrapper>
  );
};

const pureComponent = pure(FilterDate);

export { pureComponent as FilterDate };
